module.exports = __webpack_public_path__ + "static/media/ic_family_dashboard.850cb9d4.svg";